import { address } from '../../config'
import axios from 'axios'
import { toast } from 'react-toastify';
import { getTranslation, getLoginLanguage } from '../../translations'

const getT = () => getTranslation(getLoginLanguage())

export const getPublicTranslations = async () => {
    const response = await axios.get(`${address}/translations/public`)
    return {
        languages: response.data?.languages || ['pl', 'en'],
        translations: response.data?.translations || {}
    }
}

export const loginUser = (email, password, _isValid, setRedirectPath) => {
    const t = getT()
    axios.post(`${address}/auth/login`, {email, password})
        .then(async res => {
            localStorage.setItem('ahpAccessToken', res.data.accessToken);
            localStorage.setItem('ahpRefreshToken', res.data.refreshToken);
            localStorage.setItem('ahpUser', res.data.userId);
            localStorage.setItem('ahpUserName', email);
            localStorage.setItem('ahpLanguage', res.data.language || 'pl');
            localStorage.setItem('ahpUserRole', res.data.role || 'USER');
            const isAdmin = (res.data.role || 'USER') === 'ADMIN';

            try {
                const headers = { 
                    "Authorization": `Bearer ${res.data.accessToken}`,
                    'Content-Type': 'application/json' 
                }
                const [userTranslationsResponse, adminTranslationsResponse] = await Promise.all([
                    axios.get(`${address}/translations`, { headers, params: { scope: 'user' } }),
                    isAdmin
                        ? axios.get(`${address}/translations`, { headers, params: { scope: 'admin' } })
                        : Promise.resolve({ data: { translations: {} } })
                ])
                localStorage.setItem('ahpCustomTranslations', JSON.stringify(userTranslationsResponse.data?.translations || {}))
                localStorage.setItem('ahpCustomAdminTranslations', JSON.stringify(adminTranslationsResponse.data?.translations || {}))
            } catch (error) {
                if (!localStorage.getItem('ahpCustomTranslations')) {
                    localStorage.setItem('ahpCustomTranslations', JSON.stringify({}))
                }
                if (!localStorage.getItem('ahpCustomAdminTranslations')) {
                    localStorage.setItem('ahpCustomAdminTranslations', JSON.stringify({}))
                }
            }

            const targetPath = isAdmin ? '/admin' : '/forms'
            if (setRedirectPath) {
                setRedirectPath(targetPath)
            }
            // Full page navigation is the source of truth; avoid racing with history.push('/forms').
            window.location.assign(targetPath)
            toast.success(t.toasts.loginSuccess, {
                position: "top-right",
                autoClose: 5000,
            })
        })
        .catch(err => {
            console.log(err)
            toast.error(t.toasts.loginError, {
                position: "top-right",
                autoClose: 5000,
            })
        })
}
